import Config from '../config';

export const TOROGOZ_API = Config.react_app_torogoz_url + '/v0';
export const REACT_APP_PEACOCK_URL = Config.react_app_peacock_url;
